import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Hakkimizda from './pages/Hakkimizda';
import Hizmetler from './pages/Hizmetler';
import HizmetAl from './pages/HizmetAl';
import Referanslar from './pages/Referanslar';
import Iletisim from './pages/Iletisim';
import HizmetVer from './pages/HizmetVer';
import KullanimKosullari from './pages/KullanimKosullari';
import KisiselVerilerinizinKorunmasi from './pages/KisiselVerilerinizinKorunmasi';
import GizlilikPolitikasi from './pages/GizlilikPolitikasi';
import CerezPolitikasi from './pages/CerezPolitikasi';
import SartlarVeKosullar from './pages/SartlarVeKosullar';
import Sartlar from './pages/Sartlar';
import Tesekkur from './pages/Tesekkur';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/hizmetler" element={<Hizmetler />} />
            <Route path="/hizmetal" element={<HizmetAl />} />
            <Route path="/tesekkur" element={<Tesekkur />} />
            {/* Diğer sayfalar buraya eklenecek */}
            <Route path="/kuryeol" element={<HizmetVer />} />
            <Route path="/referanslar" element={<Referanslar />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="/kullanim-kosullari" element={<KullanimKosullari />} />
            <Route path="/kisisel-verilerinizin-korunmasi" element={<KisiselVerilerinizinKorunmasi />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
            <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
            <Route path="/sartlar-ve-kosullar" element={<SartlarVeKosullar />} />
            <Route path="/sartlar" element={<Sartlar />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
